import ReactDOM from "react-dom";
import "./index.css";
import "./shared/theme/darkMode.css";
import App from "./App";
import { Provider } from "react-redux";
import configuretore from "./redux/reducers/configureStore";
import * as serviceWorker from "./serviceWorker";
import ThemeProvider from "./theme-provider";
import { ThemeContextProvider } from "./context/ThemeContextProvider";
import { ToastContextProvider } from "./context/ToastContextProvider";
import ToastContainer from "./components/ui/alert/ToastContainer";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { tr } from "date-fns/locale";
import { installDisableDialogBackdropClose } from "./utils/disableDialogBackdropClose";
import { configureAxios } from "./services/setupAxios";

installDisableDialogBackdropClose();
configureAxios();

// Guid migration TS hatalari webpack overlay ile tum sayfalari (login dahil) blokluyor.
if (process.env.NODE_ENV === "development") {
  const style = document.createElement("style");
  style.setAttribute("data-hide-dev-overlay", "true");
  style.textContent =
    "iframe#webpack-dev-server-client-overlay{display:none!important}";
  document.head.appendChild(style);
}

const store = configuretore();

ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ThemeContextProvider>
      <ThemeProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
          <ToastContextProvider>
            <App />
            <ToastContainer />
          </ToastContextProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </ThemeContextProvider>
  </Provider>,
  // </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorker.unregister();
